import { CurrencyPipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'moedaFormatadaGenericaPipe',
    pure: true
})

export class MoedaFormatadaGenericaPipe implements PipeTransform {

    transform(valor: any, currencyCode: string = 'BRL', symbolDisplay: string = 'symbol', digits?: string): string {
        if (!valor) {
            return '---';
        }

        let currencyPipe: CurrencyPipe = new CurrencyPipe('pt-BR');
        let newValue: string | null = currencyPipe.transform(valor, currencyCode, symbolDisplay, digits);

        if (newValue) {
            return newValue;
        } else {
            return '---';
        }
    }
}
